import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "页面不存在 - 红狐影视";
  }, []);

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <div className="flex h-20 w-20 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </div>
      <p className="mt-6 font-heading text-5xl font-extrabold text-foreground-950">
        404
      </p>
      <h1 className="mt-3 font-heading text-xl font-bold text-foreground-900">
        页面走丢了
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面可能已被移动或不存在。别担心，回到首页继续探索精彩影视内容吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
        >
          <i className="ri-film-line"></i>
          浏览电影
        </Link>
      </div>
    </div>
  );
}